// extracted by mini-css-extract-plugin
module.exports = {"bgModalColor":"#001424"};